export default __webpack_public_path__ + "static/media/star-glyph-16px.d85f6825.svg";